import { MdSnackBar } from '@angular/material';
import { Injectable } from '@angular/core';

/**
 * Generic service to show a snackbar with the provided message.
 */
@Injectable()
export class SnackBarService {
    duration = 100000; // Timeout for snackbar in milliseconds.
    actionButtonLabel = 'Close';
    action = true;
    message = '';

    constructor(public mdSnackBar: MdSnackBar) { }

    private open(): void {
        this.mdSnackBar.open(
            this.message, this.action && this.actionButtonLabel, { duration: this.duration });
    }

    showSimpleMsj(msj: string) {
      this.mdSnackBar.open(
        msj, this.action && this.actionButtonLabel, { duration: this.duration });
    }

    showStatus(
        response: any, successMsg: string, failureMsg: string) {
        // check whether there is message from the rest service.
        if (response.message && response.message !== '') {
            this.message = response.message;
        } else if (!response.flagResult && response._body && response._body !== '') {
            try {
                const anyValue = JSON.parse(response._body);
                this.message = (anyValue && anyValue.message) || failureMsg;
            } catch (e) {
                // If parsing fails (e.g., HTML error page or plain text), use failure message
                // Try to extract a meaningful message from the body if it's a string
                if (typeof response._body === 'string' && response._body.length < 200) {
                    this.message = response._body;
                } else {
                    this.message = failureMsg || 'An error occurred';
                }
            }
        } else { // Handle all the other cases.
            if (response && response.flagResult) {
                this.message = successMsg;
            } else {
                this.message = failureMsg;
            }
        }
        this.open();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/snackbar.service.ts